import React from 'react';
import { inputPropTypes } from 'Packages/FacetDesign/Components/propTypes';
import { FDStack } from '@facet-wealth/design';
import { noop } from 'Helpers/PropTypes';
import ToggleButton from 'Packages/FacetDesign/Components/Experimental/ToggleButton';

const ButtonPicklist = ({ options, value, onChange }) => {
  return (
    <FDStack direction={'row'} spacing={1} alignItems={'center'} wrap width={'100%'}>
      {options.map((option) => <ToggleButton key={option.id} option={option} value={value} onChange={onChange} />)}
    </FDStack>
  );
};

ButtonPicklist.defaultProps = {
  value: undefined,
  onChange: noop,
};

ButtonPicklist.propTypes = {
  options: inputPropTypes.options.isRequired,
  value: inputPropTypes.value,
  onChange: inputPropTypes.onChange,
};

export default ButtonPicklist;
